<template>
  <CustomModal 
    :show="showModal"
    size="xl"
    @closeModal="$emit('close')">
    <template #modal-header>
      Select Contract
    </template>
    <template #modal-body>
      <Full
        :noCreateButton="true"
        isServerSide
        @search="loadContractList()"
        @paginate="loadContractList()"
        placeholder="Search Here..."
        :filter="filters.contract"
        :table="tables.contracts"
        :pagination="paginations.contract"
        :sortChanged="sortChanged">
        <template v-slot:cell(action)="data">
          <b-button size="sm" variant="outline-primary" @click="$emit('clickContract', data.item)"><v-icon name="plus"></v-icon></b-button>
        </template>
      </Full>
    </template>
    <template #modal-footer>
      <div class="button-footer">
        <!-- <SaveButton @click="$emit('save')" label="Add"/> -->
        <CloseButton @click="$emit('close')" class="ml-2 float-right"  />
      </div>
    </template>
  </CustomModal>
</template>
<script>
import tables from '../../helpers/tables'
import { ContractApi } from '../../mixins/api'
import { ContractStatuses } from "../../helpers/enum";
import { 
  CustomModal,
  CloseButton } from '../components'
import Full from '../components/Full'
export default {
  ContractStatuses,
  components: {
    CustomModal,
    Full,
    CloseButton
  },
  mixins: [ContractApi, tables],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    params: {}
  },
  data() {
    return {
      tables: {
        contracts: {
          isBusy: false,
          fields: [
             {
              key: 'contractNo',
              label: 'CONTRACT NO',
              thClass: 'align-middle',
              thStyle: { width: '20%' },
              sortable: true
            },
            {
              key: 'tradeName',
              label: 'TRADE NAME',
              thClass: 'align-middle',
              thStyle: { width: '80%' },
              sortable: true
            },
            {
              key: 'action',
              label: '',
              thClass: 'align-middle',
              thStyle: { width: '45px' }
            },
          ],
          items: []
        }
      },
      filters: {
        contract: {
          criteria: null,
          sortBy: null,
          sortDesc: null
        }
      },
      paginations: {
        contract: {
          from: 0,
          to: 0,
          totalRows: 0,
          page: 1,
          perPage: 10,
        },
      },
    }
  },
  methods: {
    loadContractList() {
      const { contracts } = this.tables
      const { contract, contract: { perPage, page } } = this.paginations
      const { criteria, sortBy, sortDesc } = this.filters.contract
      const sortKey = sortBy === 'name' ? 'name' : 'id'
      const isDesc = sortDesc ? 'DESC' : 'ASC'

      const params = {
        ...this.params,
        paginate: true,
        perPage,
        page,
        criteria,
        sortKey,
        sortDesc: isDesc,
        contractStatusId: this.$options.ContractStatuses.APPROVED.id
      }

      contracts.isBusy = true

      this.getContractList(params)
      .then(({ data }) => {
        contracts.items = data.data
        contract.from = data.meta.from
        contract.to = data.meta.to
        contract.totalRows = data.meta.total
        contracts.isBusy = false
      })
    },
    sortChanged(event) {
      const { contract } = this.filters
      contract.sortBy =  event.sortBy
      contract.sortDesc = event.sortDesc
      this.loadContractList()
    }
  },
  computed: {
    showModal: {
      get: function() {
        return this.show
      },
      set: function(newValue) {
        return newValue
      }
    }
  },
  watch: {
    show: function (val) {
      if(val)
      this.loadContractList()
    },
  }
}
</script>